import {
  formatTimezoneForUser,
  normalizeTimezoneIdentifier,
} from '@utils/timezone';
import {isActiveWorkspaceUser} from '@utils/active-workspace-user';

export const NO_MANAGER_FILTER = '__no_manager__';
export const NO_TIMEZONE_FILTER = '__no_timezone__';

const responseUsers = (response: any): any[] => {
  if (Array.isArray(response)) return response;
  if (Array.isArray(response?.results)) return response.results;
  if (Array.isArray(response?.users)) return response.users;
  if (Array.isArray(response?.data)) return response.data;
  return [];
};

export const activeMemberUsers = (response: any): any[] =>
  responseUsers(response).filter(
    (user) => Boolean(user?.id) && isActiveWorkspaceUser(user),
  );

export const memberTimezoneId = (user: any): string => {
  const timezone = user?.timezone;
  const value =
    typeof timezone === 'string'
      ? timezone
      : timezone?.value || timezone?.timezone || timezone?.name;
  return normalizeTimezoneIdentifier(value);
};

export const filterActiveMembers = ({
  users,
  search,
  managerIds,
  timezoneIds,
}: {
  users: any[];
  search: string;
  managerIds: string[];
  timezoneIds: string[];
}) => {
  const normalizedSearch = search.trim().toLocaleLowerCase();

  return users.filter((user) => {
    const managerId =
      typeof user?.reviewer === 'string'
        ? user.reviewer
        : user?.reviewer?.id || '';
    const timezoneId = memberTimezoneId(user);
    const matchesSearch =
      !normalizedSearch ||
      [
        `${user?.firstName || ''} ${user?.lastName || ''}`.trim(),
        user?.name,
        user?.email,
        user?.jobTitle,
      ]
        .filter(Boolean)
        .some((value) =>
          String(value).toLocaleLowerCase().includes(normalizedSearch),
        );
    const matchesManager =
      managerIds.length === 0 ||
      managerIds.includes(managerId) ||
      (!managerId && managerIds.includes(NO_MANAGER_FILTER));
    const matchesTimezone =
      timezoneIds.length === 0 ||
      timezoneIds.includes(timezoneId) ||
      (!timezoneId && timezoneIds.includes(NO_TIMEZONE_FILTER));

    return matchesSearch && matchesManager && matchesTimezone;
  });
};

export const paginateMembers = (
  users: any[],
  page: number,
  pageSize: number,
) => {
  const safePageSize = Math.max(pageSize, 1);
  const firstMember = (Math.max(page, 1) - 1) * safePageSize;
  return users.slice(firstMember, firstMember + safePageSize);
};

export const formatTimezoneForDisplay = (
  timezone?: string,
  date?: Date,
): string => formatTimezoneForUser(timezone, date);
